<template>
  <div class="mb-2">
    <el-button
      class="my-2"
      type="primary"
      @click="newValidation()"
      ><i class="fas fa-plus mr-1"></i> New
      Validation</el-button
    >

    <el-table :data="validations" style="width: 100%">
      <el-table-column
        prop="label"
        label="Validation"
      ></el-table-column>
      <el-table-column
        prop="value"
        label="Value"
      ></el-table-column>
      <el-table-column label="Actions">
        <template slot-scope="scope">
          <el-button size="small" @click="edit(scope.row)"
            ><i class="far fa-edit"></i
          ></el-button>
          <el-button
            size="small"
            type="danger"
            @click="remove(scope.row)"
            ><i class="fas fa-trash"></i
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <app-field-validation-form></app-field-validation-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-field-list',

  computed: {
    ...mapGetters({
      data: 'builder/data',
      entity: 'builder/entityCurrent/current',
      validations:
        'builder/fieldValidationCurrent/listForTable',
      scaffold: 'scaffold/current',
      get: 'builder/fieldValidationCurrent/get',
    }),
  },

  methods: {
    newValidation() {
      const { commit } = this.$store;
      commit('builder/fieldValidationCurrent/new');
    },

    edit(row) {
      const validation = this.get(row.id);
      const { commit } = this.$store;
      commit(
        'builder/fieldValidationCurrent/edit',
        validation,
      );
    },

    remove(row) {
      const validation = this.get(row.id);
      const { commit } = this.$store;
      commit(
        'builder/fieldValidationCurrent/delete',
        validation,
      );
    },
  },
};
</script>

<style></style>
